// import React, { useEffect, useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Thumbs } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/thumbs";
// import { useParams, useNavigate, Link } from "react-router-dom";
// import { Product } from "types";

// interface ViewRow {
//   warehouse_name: string;
//   quantity: number;
//   zone_name: string;
//   rack_name: string;
//   bin_name: string;
// }
// const SignageViewAgentProduct = () => {
//   const { agentId } = useParams<{ agentId: string }>();
//   const { productId } = useParams<{ productId: string }>();
//   const [loading, setLoading] = useState(true);
//   const token = getAuthCookie("sessionToken");
//   const userId = getAuthCookie("userId");
//   const [product, setProduct] = useState<Product>();
//   const [order, setOrder] = useState<any>();
//   const [warehouses, setWarehouses] = useState<any[]>([]);
//   const [error, setError] = useState<string>("");
//   const [viewRows, setViewRows] = useState<ViewRow[]>([]);
//   const navigate = useNavigate();
//   // Fetch product data
//   useEffect(() => {
//     const fetchProduct = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}/agent/${agentId}/inventory/${productId}`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         if (!response.ok) {
//           throw new Error("Failed to fetch category data");
//         }
//         const data = await response.json();
//         setOrder(data);
//         console.log("order", data);
//         setProduct(data.product);
//       } catch (err) {
//         console.error("Error fetching category data:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (productId) fetchProduct();
//   }, [productId, token]);

//   // useEffect(() => {
//   //   const fetchWarehouses = async () => {
//   //     try {
//   //       const response = await fetch(
//   //         `${process.env.REACT_APP_API_URL}/warehouses`,
//   //         {
//   //           method: "GET",
//   //           headers: {
//   //             Authorization: `Bearer ${token}`,
//   //             "Content-Type": "application/json",
//   //           },
//   //         }
//   //       );
//   //       const data = await response.json();
//   //       console.log("warehouses", data);
//   //       setWarehouses(data);
//   //     } catch (err) {
//   //       setError(
//   //         err instanceof Error ? err.message : "An unknown error occurred"
//   //       );
//   //     }
//   //   };

//   //   fetchWarehouses();
//   // }, [token]);


//   useEffect(() => {
//     if (!order?.linked_installer_details?.storage_locations) return;

//     const rows = order.linked_installer_details.storage_locations?.flatMap((group: any) =>
//       group.location?.map((loc: any) => ({
//         warehouse_name: loc.warehouse_name || "",
//         quantity: loc.quantity || 0,
//         zone_name: loc.zone_name || "",
//         rack_name: loc.rack_name || "",
//         bin_name: loc.bin_name || "",
//         assigned_at: group.assigned_at || "",
//         product_location_status: group.product_location_status || "",
//         current_status: group.current_status || "",
//       }))
//     );

//     setViewRows(rows);
//   }, [order]);



//   return (
//     <div className="content">
//       <div className="">
//         <div className="">
//           {/* <h2 className="ps-4">Product Details </h2> */}
//           <div className="row justify-content-center">
//             <div className="col-md-12 col-lg-12 col-xl-12 ms-5 me-3" id="row-overlap">
//               <div className="card mt-1 card-bg-fill">
//                 <div className="card-body p-4">
//                   <div className="p-2 mt-1">
//                     <div className="row">
//                       {/* <div className="col-md-3">
//                         <div className="mb-3">
//                           {product?.image?.url !== "" ? (
//                             <div className="mb-3">
//                               <img
//                                 src={`${process.env.REACT_APP_BASE_URL}${product?.image?.url}`}
//                                 alt="Product"
//                                 className="img-fluid"
//                                 style={{ maxHeight: "200px" }}
//                               />
//                             </div>
//                           ) : ""}
//                         </div>
//                       </div> */}
//                       <div className="col-md-12">
//                         <div className="d-flex mt-2">
//                           <div className="row">
//                             <div className="col-md-8">
//                               <div className="row">
//                                 <div className="col-md-12 mb-3">
//                                   <label className="form-label table-headers">
//                                     Product Name{" "}

//                                   </label>
//                                   <input
//                                     type="text"
//                                     className="form-control table-cells"
//                                     id="name"
//                                     name="name"
//                                     value={product?.name}
//                                     readOnly
//                                   />
//                                 </div>
//                                 <div className="col-md-3 mb-3">
//                                   <label className="form-label table-headers">Brand</label>
//                                   <input
//                                     className="form-control table-cells"
//                                     id="brand"
//                                     name="brand"
//                                     value={product?.brand}
//                                     readOnly
//                                   />
//                                 </div>
//                                 <div className="col-md-3 mb-3">
//                                   <label className="form-label table-headers">Category</label>
//                                   <input type="text" className="form-control table-cells"
//                                     value={product?.category} readOnly />

//                                 </div>
//                                 <div className="col-md-3 mb-3">
//                                   <label className="form-label table-headers">
//                                     Item Condition
//                                   </label>
//                                   <input type="text"
//                                     className="form-control table-cells"
//                                     id="item_condition"
//                                     name="item_condition"
//                                     value={product?.item_condition}
//                                     readOnly
//                                   />
//                                 </div>
//                               </div>
//                             </div>

//                             <div className="col-md-4">
//                               <div className="col-md-12">
//                                 <div className="card">
//                                   <div className="card-body">
//                                     <div className="col-md-12 mt-3">
//                                       <label className="form-label table-headers ms-2">
//                                         Dimensions/Measurements (Inches)
//                                       </label>
//                                       <div className="row">
//                                         <div className="col-md-4 mb-3">
//                                           <input
//                                             type="text"
//                                             className="form-control table-cells"
//                                             id="length"
//                                             name="length"
//                                             value={product?.package_dimensions?.length}
//                                             placeholder="Length"
//                                             readOnly
//                                           />
//                                         </div>
//                                         <div className="col-md-4 mb-3">
//                                           <input
//                                             type="text"
//                                             className="form-control table-cells"
//                                             id="height"
//                                             name="height"
//                                             value={product?.package_dimensions?.height}
//                                             placeholder="Height"
//                                             readOnly
//                                           />
//                                         </div>
//                                         <div className="col-md-4 mb-3">
//                                           <input
//                                             type="text"
//                                             className="form-control table-cells"
//                                             id="width"
//                                             name="width"
//                                             value={product?.package_dimensions?.width}
//                                             placeholder="Width"
//                                             readOnly
//                                           />
//                                         </div>
//                                         <div className="col-md-4 mb-3">
//                                           <label className="form-label table-headers">
//                                             Weight(in gms)
//                                           </label>
//                                           <input
//                                             type="text"
//                                             className="form-control table-cells"
//                                             id="weight"
//                                             name="weight"
//                                             value={product?.package_dimensions?.weight}
//                                             readOnly
//                                           />
//                                         </div>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="col-md-12 ms-1">
//                               {/* Description */}
//                               <div className="mb-3">
//                                 <label className="form-label table-headers">
//                                   Product Description/Notes
//                                 </label>
//                                 <textarea
//                                   className="form-control table-cells"
//                                   id="description"
//                                   name="description"
//                                   value={product?.description}
//                                   rows={4}
//                                   readOnly
//                                 ></textarea>
//                               </div>

//                               {/* Fields Row */}
//                               <div className="row ms-1">
//                                 <div className="col-md-2 mb-3 mt-2signageofficeinven" id="row-overlap">
//                                   <label className="form-label table-headers">Threshold Quantity</label>
//                                   <input
//                                     type="number"
//                                     className="form-control table-cells"
//                                     id="threshold_qty"
//                                     name="threshold_qty"
//                                     value={product?.threshold_qty}
//                                     readOnly
//                                   />
//                                 </div>

//                                 {/* <div className="col-md-1 mb-3" id="row-overlap">
//                                   <label className="form-label table-headers">Quantity</label>
//                                   <input
//                                     type="number"
//                                     className="form-control table-cells"
//                                     id="qty"
//                                     name="qty"
//                                     // value={product?.qty}
//                                     readOnly
//                                   />
//                                 </div> */}

//                                 {/* <div className="col-md-3 mb-3" id="row-overlap">
//                                   <label className="form-label table-headers">Installer</label>
//                                   <input
//                                     name="installerId"
//                                     id="installerId"
//                                     className="form-control table-cells"
//                                     value={product?.linked_installer || ""}
//                                     readOnly
//                                   />
//                                 </div> */}

//                                 <div className="col-md-2 mb-3" id="row-overlap">
//                                   <label className="form-label table-headers">Status</label>
//                                   <input
//                                     className="form-control table-cells"
//                                     id="statuss"
//                                     name="statuss"
//                                     value={product?.status}
//                                     readOnly
//                                   />
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="col-md-12 mb-3 ms-1">
//                               <label className="form-label table-headers">
//                                 Notes for the Installer{" "}
//                               </label>
//                               <textarea
//                                 className="form-control table-cells"
//                                 id="notes"
//                                 name="notes"

//                                 value={product?.notes}
//                                 readOnly
//                               ></textarea>

//                             </div>
//                             <div className="table-wrapper ms-1" style={{ maxHeight: '300px', overflowY: 'auto' }}>
//                               <table className="table table-bordered">
//                                 <thead className="table-light">
//                                   <tr>
//                                     <th>Warehouse</th>
//                                     <th>Quantity</th>
//                                     <th>Zone</th>
//                                     <th>Rack</th>
//                                     <th>Bin Location</th>
//                                   </tr>
//                                 </thead>
//                                 <tbody>
//                                   {viewRows?.map((row, idx) => (
//                                     <tr key={idx}>
//                                       <td>
//                                         <input
//                                           className="form-control"
//                                           disabled
//                                           value={row?.warehouse_name}
//                                         />
//                                       </td>
//                                       <td>
//                                         <input
//                                           className="form-control"
//                                           type="number"
//                                           disabled
//                                           value={row?.quantity}
//                                         />
//                                       </td>
//                                       <td>
//                                         <input
//                                           className="form-control"
//                                           disabled
//                                           value={row?.zone_name}
//                                         />
//                                       </td>
//                                       <td>
//                                         <input
//                                           className="form-control"
//                                           disabled
//                                           value={row?.rack_name}
//                                         />
//                                       </td>
//                                       <td>
//                                         <input
//                                           className="form-control"
//                                           disabled
//                                           value={row?.bin_name}
//                                         />
//                                       </td>
//                                     </tr>
//                                   ))}
//                                 </tbody>
//                               </table>

//                             </div>
//                           </div>

//                         </div>

//                       </div>
//                       <div className="row mb-3 rcust-margin-4">
//                         <div className="col-md-12 d-flex justify-content-between" id="row-overlap">
//                           <button
//                             className="btn btn-outline-secondary br-8 backbutton text-end ms-4"
//                             type="button"
//                             onClick={() => navigate(-1)}
//                           >
//                             Back
//                           </button>
//                           <div></div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignageViewAgentProduct;


// SignageViewAgentProduct.tsx
import React, { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import SharedEditProductUI from "components/SignageOfficeAgentInventoryProduct";
import { getImageSrc, useVariantImageUrlMap } from "components/Tableimageshelpers";
import { getAuthCookie } from "../../utils/authCookies";
type SelectOption = { value: string; label: string };
type ViewRow = {
  warehouse_name: string;
  quantity: number;
  zone_name: string;
  rack_name: string;
  bin_name: string;
};

const conditionOptions: SelectOption[] = [
  { value: "new", label: "New" },
  { value: "used_like_new", label: "Used - Like New" },
  { value: "used_good", label: "Used - Good" },
];

const statusOptions: SelectOption[] = [
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
];

const SignageViewAgentProduct: React.FC = () => {
  const { agentId } = useParams<{ agentId: string }>();
  const { productId } = useParams<{ productId: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  // Determine the base route based on current location
  const isSignageTeammember = location.pathname.includes('/signageteammember');
  const baseRoute = isSignageTeammember ? '/signageteammember' : '/signage';

  const [loading, setLoading] = useState(true);
  const token = getAuthCookie("sessionToken") || "";
  const [product, setProduct] = useState<any>(null);
  const [order, setOrder] = useState<any>(null);
  const [uploadedFileMeta, setUploadedFileMeta] = useState<any[]>([]);

  // read-only warehouse rows (your old table)
  const [viewRows, setViewRows] = useState<ViewRow[]>([]);

  // ── Fetch product (VIEW) ─────────────────────────────────────────────
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/agent/${agentId}/inventory/${productId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!res.ok) throw new Error("Failed to fetch product");
        const data = await res.json();
        setOrder(data);
        setProduct(data?.product);

        // Map product images - check both locations
        const images = data?.product?.images || data?.product?.variants?.[0]?.images || [];
        setUploadedFileMeta(images);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    if (agentId && productId) fetchProduct();
  }, [agentId, productId, token]);

  // ── Build read-only rows for your old warehouse table ────────────────
  useEffect(() => {
    if (!order?.linked_installer_details?.storage_locations) return;

    const rows: ViewRow[] = order.linked_installer_details.storage_locations
      ?.flatMap((group: any) =>
        (group?.location || []).map((loc: any) => ({
          warehouse_name: loc?.warehouse_name || "",
          quantity: loc?.quantity || 0,
          zone_name: loc?.zone_name || "",
          rack_name: loc?.rack_name || "",
          bin_name: loc?.bin_name || "",
        }))
      ) || [];

    setViewRows(rows);
  }, [order]);

  // ── Single-option lists so selects show proper values in readOnly ────
  const brandOptionsMemo: SelectOption[] = useMemo(() => {
    const val = product?.brand_id ?? "";
    const label = product?.brand ?? "";
    return val ? [{ value: String(val), label: String(label) }] : [];
  }, [product]);

  const categoryOptionsMemo: SelectOption[] = useMemo(() => {
    const val = product?.category_id ?? "";
    const label = product?.category ?? "";
    return val ? [{ value: String(val), label: String(label) }] : [];
  }, [product]);

  const dataForMap = React.useMemo(() => (product ? product : []), [product]);
  const imageUrlMap = useVariantImageUrlMap(dataForMap, token);

  // ── Minimal Formik-like adapter for the shared UI (READ-ONLY) ────────
  const formik = useMemo(() => {
    return {
      values: {
        name: product?.name ?? "",
        sku: product?.sku ?? "",
        description: product?.description ?? "",
        
        // your shared UI reads these flat:
        qty: product?.variants?.[0]?.inventory?.[0]?.available ?? 0,
        threshold_qty: product?.threshold_qty ?? 0,

        // map from package_dimensions into flat fields expected by shared UI
        length: product?.package_dimensions?.length ?? "",
        height: product?.package_dimensions?.height ?? "",
        width: product?.package_dimensions?.width ?? "",
        weight: product?.package_dimensions?.weight ?? "",

        item_condition: product?.item_condition ?? "new",

        // IMPORTANT: shared UI uses the key "statuss"
        statuss: product?.status ?? "Active",

        brand: product?.brand_id ?? "",
        category: product?.category_id ?? "",
      },
      handleChange: () => { },
      handleBlur: () => { },
      setFieldValue: () => { },
      errors: {},
      touched: {},
    };
  }, [product]);

  // Read-only view - no file operations allowed (no-op handlers)
  const handleAddFiles = () => { };
  const handleRemovePreview = () => { };
  const handleRemoveUploaded = () => { };


  if (loading) return <div className="p-4">Loading…</div>;
  if (!product) return <div className="p-4 text-danger">Product not found.</div>;

  return (
    <div className="content">
      <SharedEditProductUI
        title="View Product"
        formik={formik}
        brandOptions={brandOptionsMemo}
        categoryOptions={categoryOptionsMemo}
        conditionOptions={conditionOptions}
        statusOptions={statusOptions}
        saving={false}
        onBack={() => navigate(-1)}
        onSubmit={() => { }}
        previewFiles={[]}
        uploadedFiles={uploadedFileMeta}
        onAddFiles={handleAddFiles}
        onRemovePreview={handleRemovePreview}
        onRemoveUploaded={handleRemoveUploaded}
        baseUrl={process.env.REACT_APP_BASE_URL}
        // VIEW MODE FLAGS
        readOnly
        hideWarehouseTable       // hide the editable table from shared UI
        hideSaveButton           // hide Save buttons
        resolveSrc={(url) =>
          getImageSrc(url, imageUrlMap) ||
          (String(url).startsWith("http") ? String(url)
            : `${process.env.REACT_APP_BASE_URL}/${String(url || "").replace(
              /^https?:\/\/[^/]+\/(uploads\/.*)/, '$1')}`)
        }
      />

      {/* <div className="">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-12 col-xl-12 ms-5 me-3" id="row-overlap">
            <div className="card mt-1 card-bg-fill">
              <div className="card-body p-4">
                <div className="p-2 mt-1">
                  <div className="table-wrapper ms-1" style={{ maxHeight: "300px", overflowY: "auto" }}>
                    <table className="table table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th>Warehouse</th>
                          <th>Quantity</th>
                          <th>Zone</th>
                          <th>Rack</th>
                          <th>Bin Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        {viewRows?.map((row, idx) => (
                          <tr key={idx}>
                            <td>
                              <input className="form-control" disabled value={row?.warehouse_name} />
                            </td>
                            <td>
                              <input className="form-control" type="number" disabled value={row?.quantity} />
                            </td>
                            <td>
                              <input className="form-control" disabled value={row?.zone_name} />
                            </td>
                            <td>
                              <input className="form-control" disabled value={row?.rack_name} />
                            </td>
                            <td>
                              <input className="form-control" disabled value={row?.bin_name} />
                            </td>
                          </tr>
                        ))}
                        {(!viewRows || viewRows.length === 0) && (
                          <tr>
                            <td colSpan={5} className="text-center text-muted">
                              No warehouse locations found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="row mb-3 rcust-margin-4">
                    <div className="col-md-12 d-flex justify-content-between" id="row-overlap">
                      <button
                        className="btn btn-outline-secondary br-8 backbutton text-end ms-4"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </button>
                      <div></div>
                    </div>
                  </div>
                </div> 
              </div> 
            </div>  
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default SignageViewAgentProduct;
